'use client' // Marcar como Client Component
import { usePathname } from 'next/navigation'
import FilterProduct from '../SideFilter'

export default function ContainerWrapper({ menuItems, productAttr }: any) {
  const pathname = usePathname()
  const isHome = pathname === '/'

  return (
    <>
      <>
        <aside
          className={`block 1350px:hidden w-66 p-4 mt-[5px] bg-white ${
            isHome ? 'hidden' : ''
          }`}
        >
          <FilterProduct menuItems={menuItems} productAttr={productAttr} />
        </aside>
      </>
    </>
  )
}
